import {css} from '@yandex-delivery/blocks/theme/css'

export const qrcodeContainer = css`
  display: flex;
  justify-content: center;
`
